import { useEffect } from 'react';
import { EventList } from '../../components/events/event-list';
import { Seo } from '../../components/seo';
import { useUIStore } from '../../store/ui-store';

function EventsListPage() {
  const { setTitle, setBreadcrumbs } = useUIStore();

  useEffect(() => {
    setBreadcrumbs([]);
    setTitle('Manage Events');
  }, [setBreadcrumbs, setTitle]);

  return (
    <>
      <Seo title="Manage Events" />
      <div className="px-12 pt-10 pb-[35px]">
        <EventList />
      </div>
    </>
  );
}

export default EventsListPage;
